import { timeZoneFromApiMap, timeZoneToApiMap } from '@flexible-reports/store/api/subscriptions/transformers/mappings';

/**
 * This function transforms the Domain Model Timezones to timezone formats understood by browser.
 * @param timezone
 */
export const transformTimezoneFromApi = (timezone: string): string | undefined => {
  return timeZoneFromApiMap[timezone];
};

/**
 * This function transforms the timezone formats by browser to Domain Model Timezones.
 * @param timezone
 */
export const transformTimezoneToApi = (timezone: string): string => {
  if (!(timezone in timeZoneToApiMap)) {
    throw new Error(`Invalid timezone: ${timezone}. Timezone does not exist in mapping.`);
  }
  return timeZoneToApiMap[timezone];
};
